import React from 'react';
import Ingestor from '../../../services/DataModels/Ingestor';
import CreateIngestorForm from '../../IngestSpecific/CreateIngestorForm';
import { withStyles, withTheme } from '@material-ui/core/styles';
import Loading from '../../DisplayOriented/Loading';
import { SnackbarContext } from '../../../services/ContextProviders/Snackbar';

const styles = theme => ({
	container: {
		width: "100%",
		overflowY: "scroll",
		overflowX: "hidden",
		"&::-webkit-scrollbar-track": {
			borderRadius: "10px",
		},
		"&::-webkit-scrollbar": {
			width: "12px",
		},
		"&::-webkit-scrollbar-thumb": {
			borderRadius: '10px',
			backgroundColor: "#5555552b"
		}
	},
	contentContainer: {
		display: "flex",
		flexWrap: "nowrap",
		margin: "32px 20%",
	}
});

class IngestDetailTab extends React.Component {

	constructor(props) {
		super(props);
		this.props = props;
		this.state = {
			dataModel: null,
		};
		this.props.tabHostProxy.setTabRefresh(this.refresh);
	}

	componentDidMount() {
		this.prepare_ingestor();
	}

	refresh = () => {
		this.setState({
			dataModel: null
		});
		new Ingestor({ _id: this.props.data._id }).readFromAPI().then((ingestor) => {
			this.props.tabHostProxy.updateTitle(ingestor._id, ingestor);
			this.props.tabHostProxy.setTabRefresh(this.refresh);
			this.props.tabHostProxy.refresh();
			this.prepare_ingestor(ingestor);
		}).catch((error) => {
			this.context.openSnackbar(error, "error");
		});
	}

	prepare_ingestor = (ingestor) => {
		let dataModel = ingestor ? new Ingestor(ingestor) : new Ingestor(this.props.data);
		this.setState({
			dataModel: dataModel
		});
	}

	cancel = () => {
		this.props.tabHostProxy.closeSelf();
	}

	create = (result) => {
		this.props.tabHostProxy.closeSelf();
		this.props.tabHostProxy.addTab("ingestor", result);
		this.props.tabHostProxy.refresh();
	}

	render() {
		const { classes, tabHostProxy } = this.props;
		const { dataModel } = this.state;

		return (
			<div className={classes.container}>
				{ dataModel === null ?
					<Loading />
					:
					<div className={classes.contentContainer}>
						<CreateIngestorForm
							className={classes.formContainer}
							tabHostProxy={tabHostProxy}
							onCreate={this.create}
							onCancel={this.cancel}
							ingestor={dataModel.data}
						/>
					</div>
				}
			</div>
		)
	}
}

IngestDetailTab.contextType = SnackbarContext;
export default withStyles(styles)(withTheme()(IngestDetailTab));
